import crop_list from "./crop_list";

const plot_manager = {
        title: String("Parcel·les"),
        plotsManagerTitle: String("Detalls de la parcel·la, {plot_name}"),
        plotsManagerNewPlotTitle: String("Crear parcel·la nova"),
        askForPlotSelectorTitle: String("Seleccioneu una parcel·la o creeu-ne una de nova"),
        paramsCropTitle: String("Paràmetres de cultiu"),
        paramsIrrigationTitle: String("Paràmetres de reg"),
        paramsSoilTitle: String("Paràmetres del sòl"),
        paramsTemperatureTitle: String("Paràmetres de temperatura"),
        profileNavButton: String("Perfil"),
        paramsNavButton: String("Paràmetres"),
        modulesNavButton: String("Estacions"),
        askForTerrainSelectorDisabled: String("Seleccioneu una finca ..."),
        plotName: String("Nom de la parcel·la"),
        plotNameInfoPopover: String("En aquest camp podeu posar el nom que voleu utilitzar per referir-vos a aquesta parcel·la."),
        plotNamePlaceholder: String("Nom de la parcel·la..."),
        plotArea: String("Superfície de la parcel·la (ha)"),
        plotAreaInfoPopover: String("Superfície de la parcel·la en hectàrees"),
        plotCropArea: String("Àrea total de cultiu (ha)"),
        plotCropAreaInfoPopover: String("Àrea total de cultiu dins de la parcel·la en hectàrees"),
        plotAssociatedTerrain: String("Finca associada"),
        plotAssociatedTerrainInfoPopover: String("Cada parcel·la pertany a una finca. Seleccioneu una finca del desplegable. En cas de no tenir-ne cap, un crea un de la secció de gestió de finques."),
        plotSigpacCode: String("Codi SIGPAC"),
        plotSigpacCodeInfoPopover: String("Codi SIGPAC"),
        paramsCropType: String("Tipus de cultiu"),
        paramsCropTypeInfoPopover: String("Tipus de cultiu"),
        paramsCropTypePlaceholder: String("Cultiu..."),
        paramsCropPlantationAge: String("Edat"),
        paramsCropPlantationAgeInfoPopover: String("Edat de la plantació en anys"),
        paramsCropPlantationAgePlaceholder: String("1"),
        paramsCropVariety: String("Varietat"),
        paramsCropVarietyInfoPopover: String("Varietat de cultiu"),
        paramsCropVarietyPlaceholder: String("varietat ..."),
        paramsCropVarietyType: String("Tipus de varietat"),
        paramsCropVarietyTypeInfoPopover: String("Segons el comportament de la varietat i el període que cobreix el seu cicle fenològic, es pot caracteritzar com més/menys temprana/tardia."),
        paramsCropVarietyTypePlaceholder: String("tipus..."),
        paramsCropTreeDistance: String("Distància entre arbres (cm)"),
        paramsCropTreeDistanceInfoPopover: String("Distància en centímetres entre els arbres"),
        paramsCropRowDistance: String("Distància entre files (cm)"),
        paramsCropRowDistanceInfoPopover: String("Distància en centímetres entre fileres d'arbres"),
        paramsCropCrownDiameter: String("Diàmetre de la Corona (cm)"),
        paramsCropCrownDiameterInfoPopover: String("Diàmetre en centímetres de la corona dels arbres"),
        paramsCropCupHeight: String("Alçada de la copa (cm)"),
        paramsCropCupHeightInfoPopover: String("Alçada en centímetres fins a la copa de l'arbre"),
        paramsCropVisibleRootDepth: String("Profunditat de les arrels (cm)"),
        paramsCropVisibleRootDepthInfoPopover: String("Profunditat de les arrels visibles"),
        paramsCropCoveredPresence: String("Presència de coberta"),
        paramsCropCoveredPresenceInfoPopover: String("Si el cultiu té presència coberta"),
        paramsCropCoefficient: String("Coeficient de cultiu"),
        paramsCropCoefficientInfoPopover: String("Coeficient de cultiu"),
        paramsCropDevelopmentCoefficient: String("Coeficient de desenvolupament de cultius"),
        paramsCropDevelopmentCoefficientInfoPopover: String("Coeficient de desenvolupament de cultius"),
        paramsIrrigationSystem: String("Sistema de reg"),
        paramsIrrigationSystemInfoPopover: String("Sistema de reg"),
        paramsIrrigationSystemPlaceholder: String("Sistema de reg ..."),
        paramsDropperType: String("Tipus de goter"),
        paramsDropperTypeInfoPopover: String("Tipus de goter utilitzats en el reg"),
        paramsDropperTypePlaceholder: String("Tipus de goter..."),
        paramsDropperFlow: String("Caudal del goter (L/H)"),
        paramsDropperFlowInfoPopover: String("Caudal del goter en litres per hora (L/H)"),
        paramsDroppersPerTree: String("Goters per arbre"),
        paramsDroppersPerTreeInfoPopover: String("Nombre de goters per arbre"),
        paramsDroppersDistance: String("Distància entre goters (cm)"),
        paramsDroppersDistanceInfoPopover: String("Distància en centímetres entre els goters"),
        paramsApplicationEfficiency: String("Eficiència de l'aplicació"),
        paramsApplicationEfficiencyInfoPopover: String("Eficiència de l'aplicació"),
        paramsSoilUniformityCoefficient: String("Coeficient uniformitat"),
        paramsSoilUniformityCoefficientInfoPopover: String("Coeficient uniformitat"),
        paramsSoilOrganicMaterial: String("Materia Organica (%)"),
        paramsSoilOrganicMaterialInfoPopover: String("Percentage de materia organica en sòl"),
        paramsSoilClayPercentage: String("Argila (%)"),
        paramsSoilClayPercentageInfoPopover: String("Percentatge d'argila que conté el sòl"),
        paramsSoilLimePercentage: String("Llima (%)"),
        paramsSoilLimePercentageInfoPopover: String("Percentatge de llima que conté el terreny"),
        paramsSoilSandPercentage: String("Arena (%)"),
        paramsSoilSandPercentageInfoPopover: String("Percentatge d'arena que conté el terreny"),
        paramsSoilSoilTexture: String("Textura del sòl"),
        paramsSoilSoilTextureInfoPopover: String("Textura del sòl"),
        paramsSoilSoilTexturePlaceholder: String("Textura ..."),
        paramsSoilTextureType: String("Tipus de textura"),
        paramsSoilTextureTypeInfoPopover: String("Tipus de textura del sòl"),
        paramsSoilTextureTypePlaceholder: String("Tipus..."),
        paramsTemperatureMax: String("Temperatura màxima (ºC)"),
        paramsTemperatureMaxInfoPopover: String("La temperatura màxima permesa."),
        paramsTemperatureMin: String("Temperatura mínima (ºC)"),
        paramsTemperatureMinInfoPopover: String("La temperatura mínima permesa"),
        paramsTemperatureKTCoefficient: String("Coeficient KT"),
        paramsTemperatureKTCoefficientInfoPopover: String("Coeficient KT"),
        paramsTemperatureExtraterrestrialSolarRadiation: String("Radiació solar extraterrestre"),
        paramsTemperatureExtraterrestrialSolarRadiationInfoPopover: String("Radiació solar extraterrestre basada en la latitud"),
        month0: String("Gener"),
        month1: String("Febrer"),
        month2: String("Marxar"),
        month3: String("Abril"),
        month4: String("Maig"),
        month5: String("juny"),
        month6: String("Juliol"),
        month7: String("Agost"),
        month8: String("Setembre"),
        month9: String("Octubre"),
        month10: String("Novembre"),
        month11: String("Desembre"),
        plotModuleAddNew: String("Afegir una estació nova"),
        plotModuleNameHeader: String("Nom de l'estació"),
        plotModuleActionHeader: String("Accions"),
        plotModuleTypeHeader: String("Tipus d'estació"),
        plotModuleEnabledHeader: String("Estat"),
        plotModuleInstallationDateHeader: String("Data d'instal·lació"),
        plotModuleActionModify: String("Modificar l'estació"),
        plotModulesNoModuleInList: String("Aquesta parcel·la no conté cap estació."),
        plotNewPlotButton: String("Crear una parcel·la nova"),
        plotUpdate: String("Actualitzar les dades de la parcel·la"),
        plotRestore: String("Restaurar tots els camps"),
        clayey: String("Argila"),
        claySandy: String("Argilo-arenosa"),
        claySilty: String("Argilo-llimosa"),
        claySiltyLoam: String("Franca Argilo-llimosa"),
        clayerLoam: String("Franco-Argilosa"),
        sandyClayLoam: String("Franca Argilo-arenosa"),
        loamy: String("Franca"),
        siltyLoam: String("Franca-Llimosa"),
        silty: String("Llimosa"),
        sandyLoam1: String("Franca-Arenosa"),
        sandyLoam2: String("Franca-Arenosa"),
        loamySandy: String("Areno-franca"),
        sandy: String("Arenosa"),
        noTextureType: String("Tipus..."),
        fine: String("Fina"),
        average: String("Mitja"),
        thick: String("Grossa"),
        grooves: String("Ranures"),
        beams: String("Bancals"),
        lying: String("Estés"),
        sprinkling: String("Aspersió"),
        located: String("Localitzada"),
        dropper: String("Goter"),
        microtube: String("Microtub"),
        integrated: String("Integrada"),
        selfCompensated: String("Autocompensada"),
        cropVariety_early: String("Temprana"),
        cropVariety_extraEarly: String("Extra-Temprana"),
        cropVariety_normal: String("Normal"),
        cropVariety_late: String("Tardia"),
        cropVariety_extraLate: String("Extra-Tardia"),
        plotParamsNoExtraterrestrialSolarRadiation: String("Es necessita una finca associada a la parcel·la per determinar la radiació solar extraterrestre."),
        errorFieldRequired: String("Aquest camp és obligatori"),
        errorInvalidLength: String("Aquest camp requereix un mínim de {length} caràcters"),
        errorNameAlreadyExists: String("Aquest nom de la parcel·la ja existeix"),
        errorNegativeNumber: String("Aquest camp no permet números negatius"),
        minTemperatureError: String("La temperatura mínima no pot ser inferior a {temperature} ºC"),
        maxTemperatureError: String("La temperatura màxima no pot ser superior a {temperature} ºC"),
        errorsModalTitle: String("Errors a la parcel·la"),
        errorsModalBodyTitle: String("No ha estat possible crear/actualitzar la parcel·la a causa dels errors següents:"),
        errorsModalCloseButton: String("Tanca"),
        errorModalTemperatureParams: String("Hi ha algun error amb els paràmetres de temperatura."),
        errorModalCropParams: String("Hi ha algun error amb els paràmetres de cultiu."),
        errorModalIrrigationParams: String("Hi ha algun error amb els paràmetres de reg."),
        errorModalSoilParams: String("Hi ha algun error amb els paràmetres del sòl."),
        errorModalProfile: String("Hi ha algun error als camps de la secció: perfil."),
};
plot_manager.crop_list = crop_list;

export default plot_manager;